import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-hosted typography (P6.5). See admin/src/main.tsx for the rationale —
// font @font-face rules must load before tokens.css so var(--font-*) binds.
import '@fontsource-variable/geist/wght.css';
import '@fontsource-variable/jetbrains-mono/wght.css';
import '@commander/tokens/tokens.css';
import { App } from './App';

async function bootstrap() {
  // Enable MSW mocking in development when VITE_MOCK_API is set
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true') {
    const { startMocking } = await import('@commander/api-client/mocks');
    await startMocking();
    console.warn('[MSW] Mocking enabled');
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  // Dismiss the premium splash screen once React has mounted.
  // Uses a short delay to allow the first paint, then fades out
  // via CSS transition before removing from the DOM entirely.
  requestAnimationFrame(() => {
    const splash = document.getElementById('splash');
    if (splash) {
      splash.classList.add('splash--hidden');
      splash.addEventListener('transitionend', () => {
        splash.remove();
      }, { once: true });

      // Safety net: remove after 1s even if transitionend does not fire
      setTimeout(() => {
        splash.remove();
      }, 1000);
    }
  });
}

bootstrap();
